import React, { Component } from 'react';
import { intlShape, FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import CheckBox from '../../../shared-components/CheckBox/CheckBox';
const LOCALE_PREFIX = 'DE/pages/ContractPage/ContractPage';


export class AgreeToContractCheckBox extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        allowErrorPopout: PropTypes.bool.isRequired
    };

    static defaultProps = {
        allowErrorPopout: false
    };

    render() {
        const { intl, allowErrorPopout} = this.props;
        const contractAgreeLabel = (
            <div>
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.agreeToReadContractContent`}
                />
            </div>
        );
        return (
            <Field
                id="agreeToReadContract"
                name="agreeToReadContract"
                label={contractAgreeLabel}
                component={CheckBox}
                allowErrorPopout={allowErrorPopout}
                validate={isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.agreeToReadContract.agreeContractError`}))}
            />
        );
    }
}
export default injectIntl(AgreeToContractCheckBox);

